import { IconArrowLeft as ArrowLeft } from "@tabler/icons-react";
import { SectionHeader } from "../components/shared/SectionHeader";
import { TEAM_AVATAR_URLS } from "../constants/assets";

export function AboutPage({ t }) {
  return (
    <main>
      <section className="relative overflow-hidden pt-32 pb-24 md:pt-40 md:pb-32">
        <div
          className="orb"
          style={{
            width: 520,
            height: 520,
            background: "hsl(var(--brand) / 0.16)",
            top: 72,
            right: -160,
          }}
        />

        <div className="container-x relative">
          <a href="/" className="btn-pill btn-ghost mb-10 w-fit text-sm">
            <ArrowLeft className="h-4 w-4" />
            {t.about.back}
          </a>

          <SectionHeader eyebrow={t.about.eyebrow} title={t.about.title} />

          <section className="reveal mt-12 grid gap-8 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-7 md:grid-cols-12 md:p-10">
            <div className="md:col-span-4">
              <h3 className="font-display text-2xl font-medium leading-tight md:text-3xl">
                {t.about.company.title}
              </h3>
            </div>
            <div className="space-y-5 text-base leading-relaxed text-muted-foreground md:col-span-8">
              {t.about.company.copy.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </section>

          <section className="mt-20">
            <div className="reveal max-w-2xl">
              <div className="eyebrow mb-4">{t.about.team.eyebrow}</div>
              <h3 className="font-display text-[clamp(1.75rem,3.5vw,3rem)] font-medium leading-[1.05]">
                {t.about.team.title}
              </h3>
              <p className="mt-5 text-base leading-relaxed text-muted-foreground">
                {t.about.team.lead}
              </p>
            </div>

            <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-5">
              {t.about.team.members.map((member, index) => (
                <article
                  key={member.title}
                  className="reveal rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-6 text-center transition-all hover:-translate-y-0.5 hover:border-brand"
                >
                  <img
                    src={TEAM_AVATAR_URLS[index]}
                    alt={member.alt}
                    className="mx-auto h-28 w-28 rounded-full border border-[hsl(var(--border))] bg-brand-soft object-cover"
                    loading="lazy"
                  />
                  <h4 className="mt-5 text-base font-semibold leading-snug">
                    <MemberTitle title={member.title} />
                  </h4>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {member.description}
                  </p>
                </article>
              ))}
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}

function MemberTitle({ title }) {
  const commaIndex = title.indexOf(",");

  if (commaIndex === -1) return title;

  return (
    <>
      <span className="block">{title.slice(0, commaIndex).trim()}</span>
      <span className="mt-1 block text-sm text-brand">
        {title.slice(commaIndex + 1).trim()}
      </span>
    </>
  );
}
